import * as React from 'react';
import { useState } from 'react';
import {
    useListContext,
    useRefresh,
    useNotify,
    useUnselectAll,
    useTranslate,
    Confirm,
} from 'react-admin';
import Button from '@mui/material/Button';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

// Bulk resend teacher invitations for the selected teachers via POST /teacher/invitations/resend.
const BulkResendInvitationButton = () => {
    const { selectedIds } = useListContext();
    const refresh = useRefresh();
    const notify = useNotify();
    const translate = useTranslate();
    const unselectAll = useUnselectAll('teacher');
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        setConfirmOpen(false);
        try {
            const res = await fetch(
                `${process.env.REACT_APP_INFRA_API}/teacher/invitations/resend`,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                    body: JSON.stringify({ guids: selectedIds }),
                }
            );
            if (!res.ok) throw new Error('resend failed');
            const data = await res.json();
            notify(
                translate('resources.user.invitation.bulk_result', {
                    sent: data.sent ?? 0,
                    no_pending: data.no_pending ?? 0,
                    invalid_email: data.invalid_email ?? 0,
                    permanent_bounce: data.permanent_bounce ?? 0,
                    errors: data.errors ?? 0,
                }),
                { type: 'info' }
            );
            unselectAll();
            refresh();
        } catch (e) {
            notify('resources.user.invitation.bulk_error', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                color="primary"
                size="small"
                startIcon={<ForwardToInboxIcon />}
                disabled={loading}
                onClick={() => setConfirmOpen(true)}
            >
                {translate('resources.user.invitation.bulk_resend')}
            </Button>
            <Confirm
                isOpen={confirmOpen}
                loading={loading}
                title={translate(
                    'resources.user.invitation.bulk_confirm_title'
                )}
                content={translate(
                    'resources.user.invitation.bulk_confirm_content',
                    { count: selectedIds.length }
                )}
                onConfirm={handleConfirm}
                onClose={() => setConfirmOpen(false)}
            />
        </>
    );
};

export default BulkResendInvitationButton;
